import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Container,
  ModalHeader,
  Row,
  Spinner
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//Import Common Component
import {
  ErrorModal,
} from "components/Common/CombinedComponents";
import { getDateTime, } from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import { Form, Formik, Field } from "formik";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";

import RavenFormikField from "components/Common/RavenFormikField";
import {
  userDefinitionsApiError,
  insertUserKeys,
  getUserByUserName,
  getUserEncryptionKeyByMerchantGuid,
  getUserByUserNameSync
} from "../../store/actions";
import userDefinition from "pages/SystemGeneral/UserDefinition/userDefinition";

class KeyDefinition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordList: [],
      detailRecordList: [],
      record: "",
      errorModal: false,
      addAnother: false,
      isedit: false,
      isDetail: false,
      recordLoadedUserNameSt: false,
      recordcolumns: [
        {
          headerName: this.props.t("chargebackNumber"),
          field: "chargebackNumber",
        },
        {
          headerName: this.props.t("cardNumber"),
          field: "cardNo",
        },
        {
          headerName: this.props.t("transactionAmount"),
          field: "transactionProvisionSettle.f004",
        },
        {
          headerName: this.props.t("chargebackAmount"),
          field: "chargebackAmount",
        },
        {
          headerName: this.props.t("currency"),
          field: "transactionProvisionSettle.f049",
        },
        {
          headerName: this.props.t("updateDateTime"),
          field: "updateDateTime",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
      ],
    };

    this.toggle = this.toggle.bind(this);
    this.handleDetailClick = this.handleDetailClick.bind(this);
    this.handleValidRecordSubmit = this.handleValidRecordSubmit.bind(this);
  }

  //#region Base Operations
  componentDidMount() {
    this.props.apiError("");

    const {
      onGetUserByUserName,
      onGetUserEncKeyByMerchantGuid
    } = this.props;

    const username = localStorage.getItem("username");

    onGetUserByUserName(username);

  }
  componentDidUpdate(prevProps) {
    const { error, onGetUserEncKeyByMerchantGuid } = this.props;
    if (prevProps.error !== error) {
      this.setState({ error: error });
    } 
  }

  //#endregion

  //#region Cruid Operations

  handleAddRecordClick = () => {
    this.setState({ record: "", isEdit: false });
    this.toggle();
  };

  handleDetailClick = values => {

    this.setState({
      record: values,
      addAnother: false,
      isDetail: true,
      isEdit: false
    });
    this.toggle();
  };

  handleValidRecordSubmit = values => {
    const { onInsertUserKeys, onGetUserByUserName } = this.props;

    values.userName = localStorage.getItem("username")
    values.apiKey = values.encKey;
    delete (values.encKey);
    onInsertUserKeys(values);
    this.setState({ recordLoadedUserNameSt: false })

    onGetUserByUserName(values.userName );

    !this.state.addAnother && this.toggle();
  };

  //#endregion

  //#region Dom Elements Design


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (this.state.modal) {
      setTimeout(() => this.setState({ isDetail: false }), 150);
    }
  }

  render() {
    const { recordList, recordListEncKey, recordLoading, recordLoadingGetUserKey, recordLoadingUserName, onGetUserEncKeyByMerchantGuid } = this.props;
    const { error, recordLoadedUserNameSt } = this.state;

    if (!recordLoadingUserName && !recordLoadedUserNameSt && this.props.recordList.merchantGuid != undefined) {
      onGetUserEncKeyByMerchantGuid(this.props.recordList.merchantGuid)
      this.setState({ recordLoadedUserNameSt: true })
    }

    return (
      <React.Fragment>
        {error && (
          <ErrorModal
            errorMessage={error}
            onCloseModalClick={() => this.setState({ error: undefined })}
          />
        )}
        <ToastContainer />
        {(recordLoading || recordLoadingGetUserKey || recordLoadingUserName) ? (
          <Spinner className="position-absolute top-50 start-50 primary" />
        ) : (<div className="page-content">
          <Container fluid>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <Row>
                      <Col>
                        <Formik
                          enableReinitialize={true}
                          disabled={true}
                          initialValues={{
                            encKey: recordListEncKey && recordListEncKey[0]?.apiKey ? atob(recordListEncKey[0].apiKey) : ""
                          }}
                          validationSchema={Yup.object().shape({
                            encKey: Yup.string()
                              .min(15, this.props.t("minLengthError").format("15"))
                              .required(this.props.t("mustBe")),
                          })}
                          onSubmit={values => {
                            this.handleValidRecordSubmit(values);
                          }}
                        >
                          {({
                            errors,
                            touched,
                          }) => (
                            <Form>
                              <Row>
                                <Col lg={12} className="col-12">
                                  <h1 className="text-primary">
                                    {this.props.t(
                                      "keyDefinitionTitle",
                                    )}
                                  </h1>
                                  <br></br>
                                  <ul>
                                    <h4 className="text-primary">
                                      <li>
                                        {this.props.t("keyDefinitionOne")}
                                      </li>
                                      <br></br>
                                      <li>
                                        {this.props.t(
                                          "keyDefinitionThree",
                                        )}
                                      </li>
                                      <br></br>
                                      <li>
                                        {this.props.t(
                                          "keyDefinitionFour",
                                        )}
                                      </li>
                                    </h4>
                                  </ul>
                                </Col>
                                <Row>
                                  <Col lg={6} className="col-6">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"apiKey"}
                                      label={"clientID"}
                                      type="text"
                                      value={recordList.clientId}
                                      isEdit={false}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={6} className="col-6">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"apiKeySecret"}
                                      label={"clientSecret"}
                                      type="text"
                                      value={recordList.clientSecret}
                                      isEdit={false}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={6} className="col-6">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"encKey"}
                                      label={"encKey"}
                                      type="text"

                                    />
                                  </Col>
                                </Row>
                              </Row>
                              <Row>
                                <Col lg={6}>
                                  <div
                                    style={{
                                      textAlign: "right",
                                    }}
                                  >
                                    <button
                                      type="submit"
                                      className="btn btn-success save-event"
                                      style={{ marginRight: "3px" }}
                                    >
                                      {this.props.t("save")}
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                              <ModalHeader
                                style={{ marginBottom: "10px" }}
                              ></ModalHeader>
                            </Form>
                          )}
                        </Formik>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>)
        }
      </React.Fragment>
    );
  }
}

KeyDefinition.propTypes = {
  recordList: PropTypes.any,
  onGetRecordList: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  onInsertUserKeys: PropTypes.func,
  onGetUserByUserName: PropTypes.func,
  onGetUserEncKeyByMerchantGuid: PropTypes.func,
  recordListEncKey: PropTypes.any,
  recordLoading: PropTypes.bool,
  recordLoadingGetUserKey: PropTypes.bool,
  recordLoadingUserName: PropTypes.bool
};

const mapStateToProps = ({ UserDefinition }) => ({
  error: UserDefinition.error,
  recordList: UserDefinition.recordListUser,
  recordListEncKey: UserDefinition.recordListUserEncKey,
  recordLoading: UserDefinition.loading,
  recordLoadingGetUserKey: UserDefinition.loadingGetUserKey,
  recordLoadingUserName: UserDefinition.loadingUserName
});

const mapDispatchToProps = dispatch => ({
  apiError: error => dispatch(userDefinitionsApiError(error)),
  onInsertUserKeys: record => dispatch(insertUserKeys(record)),
  onGetUserByUserName: userName => dispatch(getUserByUserNameSync(userName)),
  onGetUserEncKeyByMerchantGuid: record => dispatch(getUserEncryptionKeyByMerchantGuid(record))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(KeyDefinition));
